import latLngMap from 'root/global_configs/latLngMap.json';
import getLocale from 'root/utils/locale/getLocale';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import { GeoMonster } from 'root/utils/cookies/geoMonster';

const googlePlacesFieldAutocomplete = (el, callback) => {
    // this will be reassigned inside autocompleteInit() after passing this callback to Google's library in the DOM
    // Once assigned then we can use this var in other functions to get Google's Places object
    let googleMapsAutocompleteObject = null;
    const loadGoogleMapApiDynamically = () => {
        // include once
        if (!document.querySelector(`[data-google-maps-places-${el.name}-script]`)) {
            const script = document.createElement('script');
            script.src =
                'https://maps.googleapis.com/maps/api/js?key=AIzaSyDBJpSb6zIU17MdmN7WN6TaCM_PnDequV4&libraries=places&callback=initAutocomplete';
            script.defer = true;
            script.setAttribute(`data-google-maps-places-${el.name}-script`, 'true');
            window.initAutocomplete = initAutocomplete;
            // Append the 'script' element to 'head'
            document.head.appendChild(script);
        }
    };
    const getGooglePlaceObject = () => {
        const place = googleMapsAutocompleteObject.getPlace();
        return place && place.address_components;
    };

    const getTldLocaleCoordinates = () => {
        const locale = getLocale() ? getLocale() : 'hq';
        return {
            latitude: latLngMap[locale].lat,
            longitude: latLngMap[locale].lng,
        };
    };

    const getGeoData = () => {
        const gm = new GeoMonster();
        //the tld will be a fallback in case the latitude/longitude has not been set in the geoConfig cookie.
        const latitude = gm.getField('latitude')
            ? gm.getField('latitude')
            : getTldLocaleCoordinates().latitude;

        const longitude = gm.getField('longitude')
            ? gm.getField('longitude')
            : getTldLocaleCoordinates().longitude;
        return {
            latitude,
            longitude,
        };
    };

    const initAutocomplete = () => {
        // The search will be biased in favor of the domain. Ex: on lightspeedhq.de the DE addresses will show first
        const domainBiasedBounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(getGeoData().latitude, getGeoData().longitude)
        );
        const options = {
            bounds: domainBiasedBounds,
            types: ['geocode'],
        };
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types
        googleMapsAutocompleteObject = new google.maps.places.Autocomplete(el, options);

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        googleMapsAutocompleteObject.setFields(['address_component']);

        // a fallback in case the user entered the address manually
        google.maps.event.addDomListener(el, 'blur', function () {
            // once the address has been entered with a google api the place object will no longer be undefined
            // this will take place only if the user entered the address manually from the first time
            // any attempts to re-enter the address manually after the user selected the address from the list, will not take effect
            if (getGooglePlaceObject() === undefined || getGooglePlaceObject() === null) {
                return callback(el, null);
            }
        });

        google.maps.event.addDomListener(el, 'keydown', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
        });

        google.maps.event.addListener(
            googleMapsAutocompleteObject,
            'place_changed',
            function () {
                return callback(el, getGooglePlaceObject());
            }
        );
    };

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    const geolocate = () => {
        if (navigator.geolocation) {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };
            const success = function (position) {
                const geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                const circle = new google.maps.Circle({
                    center: geolocation,
                    radius: position.coords.accuracy,
                });
                googleMapsAutocompleteObject.setBounds(circle.getBounds());
            };
            const error = function error(err) {
                LoggingHandler().logError(err, {
                    searchTerm: 'geolocation-current-position-request',
                    tags: ['forms'],
                    fileName: 'googlePlacesFieldAutocomplete.js',
                });
            };
            navigator.geolocation.getCurrentPosition(success, error, options);
        }
    };
    const init = () => {
        loadGoogleMapApiDynamically();
        geolocate();
    };
    return {
        init,
    };
};

export default googlePlacesFieldAutocomplete;
